import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseFollowingAuctionsProps<T> = {
  filters?: { page?: number; isCompletelyDone?: boolean }
  mapper?: (data: any) => T
}

export const useFollowingAuctions = <T,>({
  filters: { page, isCompletelyDone } = {},
  mapper = Mapper.default<T>(),
}: UseFollowingAuctionsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const { data: { data, meta } = defaultTransformerResponse<T>(), ...rest } = useQuery({
    queryKey: ['maintenanceAuctionsFollowing', page, isCompletelyDone],
    queryFn: () =>
      privateAxios.get('/maintenance/establishment_choice/auction_entries/following', {
        params: { page, is_completely_done: isCompletelyDone },
      }),
    select: (response: { data: { data: any[]; meta: MetaResponse } }) => ({
      data: mapper(response?.data?.data),
      meta: response?.data?.meta,
    }),
    placeholderData: keepPreviousData,
  })

  return { data, meta, ...rest }
}
